import React, { Fragment } from "react"
import { FaArrowAltCircleRight, FaClock } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { getOrderStatusColor, getOrderStatusTitle } from "utils"
import classes from "./OrderDetailsStatus.module.scss"

const OrderDetailsStatus = props => {
  const { order } = props

  const [t] = useTranslation()

  const title = getOrderStatusTitle(order, t)

  const color = getOrderStatusColor(order)

  return (
    <Fragment>
      <div className={classes["status-container"]}>
        <span>{t("وضعیت_سفارش")}:</span>

        <div className={classes["status"]}>
          <b
            className={classes["progress"]}
            style={{ backgroundColor: color }}
          >
            {t(title)}
          </b>
        </div>

        {
          order.isOrderLate &&
          <div className={classes["status"]}>
            <b
              className={classes["progress"]}
              style={{ backgroundColor: "orange" }}
            >
              <FaClock />
              {t("تاخیر")}
            </b>
          </div>
        }

        {
          order.isOrderReady &&
          <div className={classes["status"]}>
            <b
              className={classes["progress"]}
              style={{ backgroundColor: "navy" }}
            >
              <FaArrowAltCircleRight />
              {t("آماده")}
            </b>
          </div>
        }
      </div>
    </Fragment>
  )
}

export default OrderDetailsStatus